import React, {
	createContext,
	useContext,
	useEffect,
	useMemo,
	useState,
} from 'react';
import { getVendorCountByCategoryData } from 'utils/apiRequests';
import cloneDeep from 'lodash/cloneDeep';
import { useCategoryAndLevelContext } from './VendorCategoryLevelProvider';
import { generateToolTip, spendFormatter } from 'utils/filterNames';
const VendorCount = createContext();
// const initialCategoryLevel = {
// 	categoryName: '',
// 	level: 1,
// 	breadcrumbs: ['All Count'],
// };

export const VendorCountProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [chartData, setChartData] = useState([]);

	// const [categoryAndLevel, setCategoryLevel] = useState({
	// 	...initialCategoryLevel,
	// });
	const { categoryAndLevel } = useCategoryAndLevelContext();

	useEffect(
		() => {
			getData();
		},
		[categoryAndLevel]
	);

	const getData = () => {
		if (categoryAndLevel.level <= 4) {
			setIsLoading(true);
			const payload = {
				categoryName: categoryAndLevel.categoryName,
				categoryLevel: categoryAndLevel.level,
			};
			getVendorCountByCategoryData(payload)
				.then(response => {
					if (response.succeeded) {
						if (response.data !== null) {
							const seriesData = cloneDeep(response.data);
							setChartData(
								seriesData.map(obj => ({
									name: obj.category,
									value: obj.count,
									colorValue: obj.count,
									// tooltip: generateToolTip({
									// 	...obj,
									// 	['spend']: spendFormatter(obj.spend),
									// }),
								}))
							);
							setIsLoading(false);
						} else {
							setChartData([]);
							setIsLoading(false);
						}
					} else {
						setChartData([]);
						setIsLoading(false);
					}
				})
				.catch(() => setIsLoading(false));
		}
	};

	const memoizedValue = useMemo(
		() => {
			return {
				isLoading,
				chartData,
				// categoryAndLevel,
				// handleColumnClick,
			};
		},
		[isLoading, chartData, categoryAndLevel]
	);
	return (
		<VendorCount.Provider value={memoizedValue}>
			{children}
		</VendorCount.Provider>
	);
};

export const useVendorCountContext = () => {
	return useContext(VendorCount);
};
